module.exports = __WEBPACK_EXTERNAL_MODULE_rcm_mobile_components_icon__;